import { Injectable } from "@angular/core";
import { TagComponent } from "@shared/components/commons/tag/tag.component";
import { BaseGridService } from "@shared/services/base/base-grid.service";
import { ColDef } from "ag-grid-community";

@Injectable()
export class ManageTagsGridService extends BaseGridService {
  override setColDefs(actionColumn: ColDef) {
    const colDefs: ColDef[] = [
      {
        headerName: 'Tag Name',
        cellClass: 'align-items-center d-flex',
        field: 'name',
        sort: 'asc',
        cellRenderer: TagComponent,
        flex: 1
      },
      {
        headerName: 'Description',
        field: 'description',
        flex: 2
      },
      actionColumn
    ]
      .map((colDef) => ({ ...colDef, suppressHeaderMenuButton: true } as ColDef));

    this.colDefs.set(colDefs);
  }
}
